import styled, { Font, Color, css, Utils, Spacing, BorderRadius } from '@nfinite/react-hubstairs/styled'
import { Tag } from '@nfinite/react-hubstairs/components'
import { transparentize } from 'polished'

const tag = css`
  text-transform: capitalize;
  width: fit-content;
  ${Utils.generateEllipsis()}
`

function getBackgroundColor({ theme, customColor, rawColor, fade = 0 }) {
  if (rawColor) return transparentize(fade, rawColor)
  else if (customColor) return transparentize(fade, theme.getColor('tag', customColor) ?? customColor)
}

function getCustomColor({ theme, customColor, rawColor }) {
  if (rawColor) return rawColor
  else if (customColor) return theme.getColor('tag', customColor)
}

function getTagColor({ customColor }) {
  switch (customColor) {
    case 'black':
    case 'bordeaux':
      return Color.get('secondary', 'contrast')
    default:
      return Color.get('secondary')
  }
}

export const TagContainer = styled(Tag)`
  ${tag}
  ${Font.generate({ weight: 'regular', size: 's' })}
  text-align: center;
  background-color: ${getBackgroundColor};
  color: ${getTagColor};
  max-width: 100%;
`

export const TagReverseContainer = styled('p')`
  ${tag}
  ${Spacing.generateMargin({ vertical: '0' })}
  ${Font.generate({ size: 's', weight: 'bold' })}
  color: ${getCustomColor};
`

export const TagFadedContainer = styled(Tag)`
  ${tag}
  ${Font.generate({ weight: 'regular', size: 's' })}
  ${Spacing.generatePadding({ all: 'xs' })}
  background-color: ${getBackgroundColor};
  color: ${getCustomColor};
`

export const TagSquareContainer = styled('p')`
  ${tag}
  ${Font.generate({ size: 's', weight: 'bold' })}
  color: ${Color.get('text', 'contrast')};
  ${BorderRadius.generate({ all: 'xs' })}
  background-color: ${getBackgroundColor};
  ${Spacing.generatePadding({ horizontal: 'xs', vertical: 'xxs' })}
  ${Spacing.generateMargin({ vertical: '0' })}
  text-transform: ${({ hasUppercase }) => (hasUppercase ? 'uppercase' : 'capitalize')};
  flex-shrink: 0;
`
